// We also assign hover, focus, active classes to elements
// like buttons so that we can get VQA for these states.
export var whenHovered = "&.hover, &:hover";
export var whenFocused = "&.focus, &:focus[data-focus-visible-added]";
/** @deprecated use whenPressed instead. */

export var whenActive = "&.active, &:active";
export var withReducedMotion = function withReducedMotion(styles) {
  return "\n  @media (prefers-reduced-motion) {\n    ".concat(styles, "\n  }\n\n  &.reduced-motion {\n    ").concat(styles, "\n  }\n");
};
export var whenPressed = "&.active, &:active";